import { render, staticRenderFns } from "./MaterialScrapsSection.vue?vue&type=template&id=547c66bf&scoped=true&"
import script from "./MaterialScrapsSection.vue?vue&type=script&lang=js&"
export * from "./MaterialScrapsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c66bf",
  null
  
)

export default component.exports